import React, { Component } from "react";
import ElectronicVerification from "@transformd-ltd/electronic-verification";
import AbnLookupComponent from "@transformd-ltd/abn-lookup";
import { Overrides } from "@transformd-ltd/sdk";

import OneRegistryLayout from "./layouts/OneRegistry";
import Formatic from "./components/Formatic";
import { ParamsFromURL } from "./common/methods";

const formProps = {
  apiServerUrl: "https://api.transformd.com",
  serverUrl: "https://api.transformd.com/graphql",
  subscriptionServerUrl: "wss://api.transformd.com/subscriptions"
};

const params = ParamsFromURL();
class App extends Component {
  render() {
    return (
      <OneRegistryLayout>
        <div className="page__example-fsf">
          <Formatic
            {...formProps}
            formId={428}
            apiKey="50fC9221aF9D5c320b8fFbA9F00BEf0EeE890CEf96BcCC3dc6C600aadA9eF9B7"
            submissionId={params.sessionId}
            environment="Live"
            channel="master"
            config="default"
            theme="transformd"
          >
            <Overrides.OverrideFieldContainer
              type="electronicVerification"
              component={ElectronicVerification}
            />
            <Overrides.OverrideFieldContainer
              component={AbnLookupComponent}
              // this dosnt work but we need this for api
              type="abnLookup"
            />
          </Formatic>
        </div>
      </OneRegistryLayout>
    );
  }
}

export default App;
